import { jsx } from "react/jsx-runtime";
import { StyledOutOfStockIndicator } from "./styles.js";
const OutOfStockIndicator = ({ label }) => {
  return /* @__PURE__ */ jsx(StyledOutOfStockIndicator, { children: label });
};
export {
  OutOfStockIndicator
};
